import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';

export const Container = styled('div')`
  background-color: ${({ theme }) => theme.color.noir};
  border-radius: ${({ theme }) => `${theme.x1spacePx}px`};
  padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x4spacePx}px`};
  margin-bottom: ${({ theme }) => `${theme.x3spacePx}px`};

  ${media.mdDown`
    border-radius: 0;
    padding: ${({ theme }) => `${theme.x1spacePx}px ${theme.x2spacePx}px`}
  `};
`;

export const Title = styled('h2')`
  ${({ theme }) => theme.typography.xLargeStrong};
  margin-bottom: ${({ theme }) => `${theme.x1spacePx}px`};
`;

export const Description = styled('p')`
  ${({ theme }) => theme.typography.small};
`;
